export default __webpack_public_path__ + "static/media/sticker-H.03dcb2b2.png";